import React from 'react';
import clsx from 'clsx';
import { Card } from 'semantic-ui-react';
import CardHeader from './CardHeader';
import VisibilityCardMeta from './VisibilityCardMeta';
import SystemFlag from '../SystemFlag';
import CardItemDescription from './CardItemDescription';

const NameDescriptionCard = ({
  children,
  className,
  description,
  descriptionHref,
  disabled,
  entity,
  href,
  icon,
  iconColour,
  iconMessage,
  link,
  linkTarget,
  loading,
  markdown,
  meta,
  name,
  onClick,
  onSelect,
  selected,
  single,
  system,
  renderSystemFlag = () => <SystemFlag flush />,
  title,
  visibility,
  withDescriptionShowMore,
}) => (
  <Card.Content className={clsx('aridhia-name-description-card', className)}>
    <CardHeader
      disabled={disabled}
      entity={entity}
      href={href}
      icon={icon}
      iconColour={iconColour}
      link={link}
      loading={loading}
      message={iconMessage}
      onClick={onClick}
      onSelect={onSelect}
      selected={selected}
      single={single}
      text={name}
      title={title}
    >
      {children}
    </CardHeader>
    {system && (<Card.Meta>{renderSystemFlag()}</Card.Meta>)}
    {visibility && (<VisibilityCardMeta visibility={visibility} />)}
    {meta && (<Card.Meta content={meta} />)}
    <CardItemDescription
      linkTarget={linkTarget}
      href={descriptionHref}
      markdown={markdown}
      value={description}
      withShowMore={withDescriptionShowMore}
    />
  </Card.Content>
);
export default NameDescriptionCard;
